var map = {
	"./black-widow.png": 830,
	"./captain-america.png": 985,
	"./hulk.png": 920,
	"./iron-man.png": 525,
	"./search-icon.png": 674,
	"./spider-man.png": 719,
	"./thor.png": 213
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;